<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-list v-if="hasComments" two-line>
                        <template v-for="(comment, index) in complaint.comment">
                            <v-list-item
                                :key="comment.createdAt"
                            >
                                <v-list-item-avatar>
                                    <v-avatar
                                        size="40px"
                                        color="blue-grey"
                                    >
                                        <span class="white--text text-uppercase">
                                            {{ parseUserInitials(comment.createdBy.username) }}
                                        </span>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ comment.comment }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ comment.createdBy.username }} - {{ formatDate(comment.createdAt) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="index" />
                        </template>
                    </v-list>
                    <v-card-text v-else>
                        <v-alert
                            type="info"
                            text
                            border="left"
                        >
                            Brak komentarzy dla reklamacji.
                        </v-alert>
                    </v-card-text>

                    <v-card-text>
                        <v-textarea
                            v-model="newComment"
                            label="Dodaj komentarz"
                            :disabled="actionLoading || isComplaintIneditable"
                            auto-grow
                            clearable
                            hide-details
                        />
                        <v-row justify="end">
                            <v-col>
                                <v-btn
                                    color="primary"
                                    data-sentry-label="Wyślij komentarz"
                                    :disabled="newComment === null || newComment.length <= 0 || isComplaintIneditable"
                                    :loading="actionLoading"
                                    @click="addComment"
                                >
                                    Wyślij
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse.js'

export default {
    name: 'Comments',
    mixins: [ dateFormatter, parse],
    props: {
        complaint: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            newComment: '',
            actionLoading: false
        }
    },
    computed: {
        hasComments() {
            return this.complaint.comment ? this.complaint.comment.length > 0 : false
        },
        userName() {
            return this.$store.state.user.userName
        },
        userId() {
            return this.$store.state.user.userId
        },
        isDraftComplaint() {
            return this.complaint.complaintStatusId === 15
        },
        isComplaintIneditable() {
            return this.isDraftComplaint && (this.complaint.creator.id != this.userId)
        },
    },
    methods: {
        addComment() {
            this.actionLoading = true

            this.$store.dispatch('complaints/createComplaintComment', {
                comment: this.newComment,
                complaintId: this.complaint.id
            })
                .then((response) => {
                    this.complaint.comment.push(response.data)
                    this.newComment = ''
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
    },
}
</script>